import React, { useState } from 'react'
import { useRouter, useTabSwitch } from '../../hooks'
import { Nav, NavLink, NavItem, TabContent, TabPane } from '@/components/ui-compat'
import { cn } from '@/lib/utils'
import { useMyPermissions } from '../../hooks/useMyPermissions'

import ProjectInfo from './components/ProjectInfo'
import MembersPage from './members/MembersPage'

import { useTranslation } from 'react-i18next'

const Settings = () => {
  const { t } = useTranslation()
  const {
    query: { projectId },
  } = useRouter()
  const [activeTab, setActiveTab] = useTabSwitch()
  const isNew = projectId === 'new'
  // The whole members matrix is a project-admin surface: the backend gates every
  // one of its operations on PROJECT.ADMIN, so a PROJECT.EDIT-only role that can
  // still reach project settings must not be shown a tab it cannot use.
  const { can } = useMyPermissions(projectId)
  const canManageMembers = !isNew && can('ADMIN', 'PROJECT')
  const tab = activeTab === 'users' && !canManageMembers ? 'info' : activeTab

  return (
    <>
      <h1 className="text-2xl font-bold mb-3">{t('Project_info_project_settings_heading')}</h1>
      <div className="tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={cn({ active: tab === 'info' })}
              onClick={() => setActiveTab('info')}
            >
              {t('Project_info_project_settings_info_navlink')}
            </NavLink>
          </NavItem>
          {canManageMembers && (
            <NavItem>
              <NavLink
                className={cn({ active: tab === 'users' })}
                onClick={() => setActiveTab('users')}
              >
                {t('Members_tab_label')}
              </NavLink>
            </NavItem>
          )}
        </Nav>
        <TabContent activeTab={tab}>
          <TabPane tabId="info">
            <ProjectInfo />
          </TabPane>
          {canManageMembers && (
            <TabPane tabId="users">
              <MembersPage projectId={projectId} />
            </TabPane>
          )}
        </TabContent>
      </div>
    </>
  )
}

export default Settings
